export const environment = {
  production: true,
  version: '15.2.9'
};
